import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GLCodeForm from "./GLCodeForm";
import { closeModalDialog } from "../../../../../actions/layoutActions";
import propTypes from "../../../../../constants/propTypes";
import {
  performCreateRequest,
  setReload,
} from "../../../../../actions/dataComponentActions";

import { getDataComponent } from "../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../utils/formValidationUtils";
import { processCreateRequestStatus } from "../../../../../utils/dataComponentUtils";

export const dataComponentId = "GLCodesGrid";

const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions
) => {
  processCreateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

const CreateGLCodeContainer = ({
  dataComponent,
  closeModalDialog,
  clientId,
  setReload,
  glCode: { id: sourceId, ...glCode },
  performCreateRequest,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions
    );
  });

  const handleCreateCode = useCallback(
    (code, formikActions) => {
      performCreateRequest(dataComponentId, code);
      setFormikAction(formikActions);
    },
    [performCreateRequest]
  );

  return (
    <GLCodeForm
      initialValues={{
        clientId,
        ...glCode,
        code: sourceId ? `Copy of ${glCode.code}` : "",
      }}
      onSubmit={handleCreateCode}
      dataComponentId={dataComponent.dataComponentId}
    />
  );
};

CreateGLCodeContainer.defaultProps = {
  glCode: {
    description: "",
    isArchived: false,
  },
};

CreateGLCodeContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  clientId: PropTypes.string,
  glCode: propTypes.glCode,
  performCreateRequest: PropTypes.func,
  setReload: PropTypes.func,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performCreateRequest,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateGLCodeContainer);
